import { Chips, useDeviceType } from '@cian/ui-kit';
import * as styles from './styles.css';
import { clsx } from 'clsx';
import { LazyImage } from 'shared/components/LazyImage';
import { FLEXIBLE_STRATEGY_LABEL, INFO_BANNERS, OPTIONS } from './constants';
import { TInfoBanner } from './types';
import { useState } from 'react';

export const TwinBanner: React.FC = () => {
  const [activeBanner, setActiveBanner] = useState<TInfoBanner>(INFO_BANNERS[0]);
  const device = useDeviceType();

  return (
    <div className={clsx(styles['container'], styles[device])}>
      <div className={styles['chips']}>
        <Chips
          value={[activeBanner.labelValue]}
          onChipClick={value =>
            setActiveBanner(INFO_BANNERS.find(banner => banner.labelValue === value) ?? INFO_BANNERS[0])
          }
          options={OPTIONS}
        />
      </div>
      <div className={styles['banners']}>
        <div className={clsx(styles['banner'], styles['blue-banner'])}>
          <div key={activeBanner.labelValue} className={styles['banner-content']}>
            <div className={styles['banner-title']}>{activeBanner.title}</div>
            <div className={styles['banner-description']}>{activeBanner.description}</div>
            <LazyImage
              src={activeBanner.miniImage}
              alt={'mini-image ' + activeBanner.labelValue}
              wrapperClassName={styles['image-mini']}
            />
          </div>
        </div>
        <div className={clsx(styles['banner'], styles['green-banner'])}>
          <div key={activeBanner.labelValue} className={styles['banner-content']}>
            <LazyImage
              src={activeBanner.image}
              alt={'image ' + activeBanner.labelValue}
              wrapperClassName={clsx(
                styles['image'],
                activeBanner.labelValue === FLEXIBLE_STRATEGY_LABEL && styles['flexible-strategy'],
              )}
            />
          </div>
        </div>
      </div>
    </div>
  );
};
